// extracted by mini-css-extract-plugin
module.exports = {"UploadImageContainer":"UploadImageForGlobalVS_UploadImageContainer__0rdBY","slideUp":"UploadImageForGlobalVS_slideUp__apwcJ"};